import { Stepper as MuiStepper, Step as MuiStep, StepConnector as MuiStepConnector, StepLabel as MuiStepLabel, styled } from '@mui/material';

export const Stepper = styled(MuiStepper)(({ theme }) => ({
  margin: theme.spacing(4, 12, 0),

  '&.MuiStepper-vertical': {
    margin: theme.spacing(0, 12, 0, 2),
  },
}));

export const Step = styled(MuiStep, {
  shouldForwardProp: prop => prop !== 'hidden',
})(({ hidden }) => ({
  '&.MuiStep-vertical': {
    display: hidden ? 'none' : 'flex',
    flexDirection: 'column-reverse',

    '&:last-of-type': {
      '.MuiStepConnector-line': {
        display: 'none',
      },
    },
  },
}));

export const StepConnector = styled(MuiStepConnector)(({ theme }) => ({
  '&.first-connector': {
    left: theme.spacing(-6), // offset margin of stepper
  },
  '&.last-connector': {
    left: 'calc(50% + 20px)',
    right: theme.spacing(-6), // offset margin of stepper
  },
  '>.MuiStepConnector-line': {
    borderColor: theme.palette.text.disabled,
    borderWidth: '2px',
    opacity: 0.2,
  },

  '&.MuiStepConnector-vertical': {
    position: 'relative',
    top: 0,
    left: 0,

    '&.last-connector': {
      display: 'none',
    },

    '>.MuiStepConnector-line': {
      minHeight: '48px',
    },
  },
}));

export const StepLabel = styled(MuiStepLabel, {
  shouldForwardProp: prop => prop !== 'active',
})(({ theme, active }) => ({
  '& .MuiStepLabel-label': {
    color: `${theme.palette.text[active ? 'primary' : 'disabled']} !important`,
    fontFamily: `${theme.typography.fontFamily} !important`,
    fontSize: theme.typography.body2.fontSize,
    '&.Mui-active': {
      fontFamily: `${theme.typography.bold.fontFamily} !important`,
    },
    '&.Mui-disabled': {
      fontFamily: theme.typography.fontFamily,
    },
  },

  '&.MuiStepLabel-vertical': {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: theme.spacing(0),

    '.MuiStepLabel-label': {
      marginTop: 0,
      marginLeft: theme.spacing(1),
    },
  },
}));
